
import get from 'lodash/get'
import { history } from '../../services/routing'

export const resetOpenSectionState = () => {
  if (
    get(history, 'location.pathname') &&
    get(history, 'location.state.sectionId')
  ) {
    history.replace(history.location.pathname, {
      storefrontId: get(history, 'location.state.storefrontId'),
    })
  }
}
